"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MotorDeclineText = void 0;
var React = require("react");
var moment = require("moment");
var MotorDeclineText = /** @class */ (function () {
    function MotorDeclineText(props) {
        var _this = this;
        this.props = props;
        var interaction = this.props.interaction;
        var underwritingResult = interaction.underwritingResult[0];
        this.index = underwritingResult.objectReference && underwritingResult.objectReference.index ? underwritingResult.objectReference.index : 0;
        this.driver = interaction.policyHolder;
        if (underwritingResult.objectReference && underwritingResult.objectReference.objectName === "additionalDrivers" &&
            interaction.additionalDrivers && interaction.additionalDrivers.length !== 0 && interaction.additionalDrivers[this.index]) {
            this.driver = interaction.additionalDrivers[this.index];
        }
        var isPolicyHolder = false;
        if (underwritingResult.objectReference &&
            underwritingResult.objectReference.objectName &&
            underwritingResult.objectReference.objectName === "policyHolder") {
            isPolicyHolder = true;
        }
        var personalizedMessage = React.createElement("p", null,
            "Sorry...",
            React.createElement("br", null),
            "We can't insure ",
            this.driver.firstName,
            ".",
            React.createElement("br", null),
            "If you'd like to continue with your quote without ",
            this.driver.firstName,
            " included, please remove them.");
        var defaultMessage = React.createElement("p", null,
            "Sorry...",
            React.createElement("br", null),
            "...we can't insure you.");
        this.underwritingResultCustomerWordings = [
            {
                key: "UW001",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW002",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW003",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW004",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW005",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW006",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW007",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW008",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW010",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW011",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW013",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW016",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW019",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "We can't insure ",
                    this.driver.firstName,
                    " without their driving licence number")
            },
            {
                key: "UW020",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW021",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW023",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of the driving licence you have.")
            },
            {
                key: "UW024",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW025",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW028",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your age.")
            },
            {
                key: "UW030",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we only insure a maximum of 6 drivers on 1 car.")
            },
            {
                key: "UW031",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we only insure a maximum of 8 drivers on 1 account.")
            },
            {
                key: "UW032",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because one of your drivers is not old enough for us to insure them on one of the cars you have selected.")
            },
            {
                key: "UW033",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your driving history.")
            },
            {
                key: "UW034",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your claims history.")
            },
            {
                key: "UW035",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your claims history.")
            },
            {
                key: "UW036",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your claims history.")
            },
            {
                key: "UW037",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your claims history.")
            },
            {
                key: "UW038",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your claims history.")
            },
            {
                key: "UW039",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your claims history.")
            },
            {
                key: "UW040",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your driving history.")
            },
            {
                key: "UW041",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your driving history.")
            },
            {
                key: "UW042",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your driving history.")
            },
            {
                key: "UW043",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your driving history.")
            },
            {
                key: "UW044",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of your driving history.")
            },
            {
                key: "UW045",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of the driving history of you or your drivers.")
            },
            {
                key: "UW046",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of the driving history of you or your drivers.")
            },
            {
                key: "UW47",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of the driving history of you or your drivers.")
            },
            {
                key: "UW048",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of the driving history of you or your drivers.")
            },
            {
                key: "UW049",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of the driving history of you or your drivers.")
            },
            {
                key: "UW050",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW052",
                value: isPolicyHolder ? defaultMessage : personalizedMessage
            },
            {
                key: "UW054",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW055",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW056",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW059",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW060",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW061",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW064",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW066",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW067",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                    React.createElement("br", null),
                    "For example:",
                    React.createElement("br", null),
                    "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.",
                    React.createElement("br", null),
                    "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.",
                    React.createElement("br", null),
                    "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover.")
            },
            {
                key: "UW068",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                    React.createElement("br", null),
                    "For example:",
                    React.createElement("br", null),
                    "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.",
                    React.createElement("br", null),
                    "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.",
                    React.createElement("br", null),
                    "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover.")
            },
            {
                key: "UW069",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                    React.createElement("br", null),
                    "For example:",
                    React.createElement("br", null),
                    "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.",
                    React.createElement("br", null),
                    "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.",
                    React.createElement("br", null),
                    "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover.")
            },
            {
                key: "UW070",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                    React.createElement("br", null),
                    "For example:",
                    React.createElement("br", null),
                    "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.",
                    React.createElement("br", null),
                    "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.",
                    React.createElement("br", null),
                    "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover.")
            },
            {
                key: "UW071",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                    React.createElement("br", null),
                    "For example:",
                    React.createElement("br", null),
                    "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.",
                    React.createElement("br", null),
                    "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.",
                    React.createElement("br", null),
                    "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover.")
            },
            {
                key: "UW072",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can\u2019t offer you a quote because of the number of modifications to the ",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].make,
                    ", ",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].model,
                    " (",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].registrationNumber,
                    ").")
            },
            {
                key: "UW073",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW076",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW077",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW078",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "Based on some of the information you've provided, we're unable to give you a quote.")
            },
            {
                key: "UW079",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you. This could be for a number of reasons, including your age or driving experience for the car you\u2019d like to insure.")
            },
            {
                key: "UW080",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you. This could be for a number of reasons, including your age or driving experience for the car you\u2019d like to insure.")
            },
            {
                key: "UW081",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "Based on some of the information you've provided, we're unable to give you a quote.")
            },
            {
                key: "UW082",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "Based on some of the information you've provided, we're unable to give you a quote.")
            },
            {
                key: "UW083",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you. This could be for a number of reasons, including your age or driving experience for the car you\u2019d like to insure.")
            },
            {
                key: "UW084",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW085",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we only insure a maximum of 3 vehicles on 1 account.",
                    React.createElement("br", null),
                    "If you'd like to continue with your quote please remove ",
                    this.props.interaction.vehicles && this.props.interaction.factors.numberOfVehicles ?
                        this.props.interaction.vehicles.length + this.props.interaction.factors.numberOfVehicles - 3
                        : "some",
                    " of the vehicles")
            },
            {
                key: "UW086",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we need ",
                    this.driver.firstName,
                    " to be assigned as a driver to at least one vehicle.")
            },
            {
                key: "UW087",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote for the ",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].make,
                    ", ",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].model,
                    " (",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].registrationNumber,
                    ") because of the relationship between you and the registered keeper of the car.")
            },
            {
                key: "UW088",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW089",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    (function () {
                        if (_this.props.interaction.numberOfVehicles === 1) {
                            return (React.createElement("p", null,
                                "...we can't offer you a quote on ",
                                _this.props.interaction.vehicles && _this.props.interaction.vehicles[_this.index] &&
                                    _this.props.interaction.vehicles[_this.index].make,
                                ", ",
                                _this.props.interaction.vehicles && _this.props.interaction.vehicles[_this.index] &&
                                    _this.props.interaction.vehicles[_this.index].model,
                                " (",
                                _this.props.interaction.vehicles && _this.props.interaction.vehicles[_this.index] &&
                                    _this.props.interaction.vehicles[_this.index].registrationNumber,
                                ") because one of your drivers does not have enough driving experience for us to insure them on this type of car."));
                        }
                        else {
                            return (React.createElement("p", null, "...we can't offer you a quote because one of your drivers does not have enough driving experience for us to insure them on one of the cars you have selected."));
                        }
                    })())
            },
            {
                key: "UW090",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW093",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW094",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW095",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because we require a tracker to be fitted to the ",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].make,
                    ", ",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].model,
                    " (",
                    this.props.interaction.vehicles && this.props.interaction.vehicles[this.index] &&
                        this.props.interaction.vehicles[this.index].registrationNumber,
                    ").")
            },
            {
                key: "UW096",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW097",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW098",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car.")
            },
            {
                key: "UW099",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't offer you a quote because of the driving history of you or your drivers.")
            },
            {
                key: "UW103",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW106",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...you can only add one temporary driver per subscription month.")
            },
            {
                key: "UW107",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...you can only replace your car up to two times per subscription month.")
            },
            {
                key: "UW108",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we don\u2019t insure this type of car under this offering.",
                    React.createElement("br", null))
            },
            {
                key: "UW109",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                    React.createElement("br", null),
                    "For example:",
                    React.createElement("br", null),
                    "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.",
                    React.createElement("br", null),
                    "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.",
                    React.createElement("br", null),
                    "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover.")
            },
            {
                key: "UW110",
                value: React.createElement("p", null,
                    "Sorry we can't insure you...",
                    React.createElement("br", null),
                    "\"Based on some of the information you\u2019ve provided, we\u2019re unable to give you a quote.",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "We check the information you provide against a range of industry databases. If there\u2019s a mismatch in these details, we might not be able to provide you with a quote.\"",
                    React.createElement("br", null),
                    "For example:",
                    React.createElement("br", null),
                    "- Details of any previous claims made by drivers on the account. This includes the dates of any claims, whether the claim was fault or non-fault, regardless of whether the driver had a policy in their own name at the time.",
                    React.createElement("br", null),
                    "- Use of the car. The registered keeper or main user and where the vehicle is kept may affect our ability to provide cover so it's important this is correctly recorded.",
                    React.createElement("br", null),
                    "- The driving history for each driver. Driving history for each driver may affect our ability to provide cover.")
            },
            {
                key: "UW111",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW112",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW113",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW114",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW115",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UW116",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can\u2019t insure this driver.")
            },
            {
                key: "UW121",
                value: (React.createElement(React.Fragment, null,
                    React.createElement("p", null,
                        "Sorry...",
                        React.createElement("br", null),
                        "you or any additional drivers have an unspent conviction and we can't insure you anymore"),
                    React.createElement("p", null,
                        "We will cancel your cover in 7 days on ",
                        moment().add(7, "days").endOf("day").format("D MMM YYYY, HH:mm"))))
            },
            {
                key: "UW124",
                value: defaultMessage
            },
            {
                key: "UW125",
                value: defaultMessage
            },
            {
                key: "UW126",
                value: defaultMessage
            },
            {
                key: "UW127",
                value: defaultMessage
            },
            {
                key: "UW128",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...you can only add car up to two times per subscription month.")
            },
            {
                key: "UW129",
                value: defaultMessage
            },
            {
                key: "UW130",
                value: defaultMessage
            }
        ];
    }
    ;
    return MotorDeclineText;
}());
exports.MotorDeclineText = MotorDeclineText;
//# sourceMappingURL=MotorDeclineText.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/MotorDeclineText.js
// module id = 3655
// module chunks = 0